import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_DASHBOARD } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import Loader from "@/components/Loader";

const Dashboard = lazy(() => import("../pages/dashboard/dashboard.container"));

const dashboardRoutes = [
  {
    path: PATH_DASHBOARD,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
    ],
  },
];

export default dashboardRoutes;
